import { createFileRoute } from '@tanstack/react-router';

import {
  resolveRange,
  supportReportQueryOptions,
  SupportReportPage,
  todayIn,
} from '@/features/reports';

export const Route = createFileRoute('/_authed/_active/s/$storeId/reports/support')({
  staticData: { crumb: 'reports:tabs.support' },
  loaderDeps: ({ search }) => ({ range: search.range, from: search.from, to: search.to }),
  loader: ({ context, params, deps }) =>
    context.queryClient
      .query({
        ...supportReportQueryOptions(
          params.storeId,
          resolveRange(deps, todayIn(context.store.timezone)),
        ),
        staleTime: 'static',
      })
      .catch(() => undefined),
  component: SupportReportPage,
});
